export const MODEL_THEME_DARK = "dark"
export const MODEL_THEME_LIGHT = "light"

export const currentPromotion = [
  {
    text: "12/15 前 全車系送手機架(S2 Cafe Race送防水包)",
    link: "//promotion.gogoro.com/tw/phone-holder-gift-sep-nov/",
    limit: false,
    code: "EVT193",
    startDate: "2019-09-26",
    endDate: "2019-12-15",
  },
  {
    text: "12/31 前 Gogoro 3 全車系購車送限量安全帽",
    link: "//promotion.gogoro.com/tw/gogoro-3-free-helmet/",
    limit: false,
    code: "EVT199",
    startDate: "2019-11-01",
    endDate: "2019-12-31",
  },
  {
    text: "防疫放心騎 新購車 電池資費 $0元起！",
    link: "//network.gogoro.com/tw/promotions/2020-299x6-promotion",
    limit: false,
    code: "EVT267",
    startDate: "2020-04-13",
    endDate: "2020-05-15",
  },
  {
    text: "指定車款購車金 (現折$2,000)",
    link: "//promotion.gogoro.com/tw/gogoro-sp-may-jun",
    limit: false,
    code: "EVT283",
    startDate: "2020-05-16",
    endDate: "2020-06-01",
  },
  {
    text: "購買 S3 系列享「一年免費性能提升方案」",
    link: "//promotion.gogoro.com/tw/s3-sp",
    limit: false,
    code: "EVT294",
    startDate: "2020-06-23",
    endDate: "2020-07-14",
  },
  {
    text: "機車汰舊換新加碼送「5 萬元車碰車險」",
    link: "//promotion.gogoro.com/tw/4-stroke-replacement-sp",
    limit: false,
    code: "EVT224",
    startDate: "2020-01-01",
    endDate: "2020-06-30",
  },
  {
    text: "全車系購車送「極輕都會風雨衣」",
    link: "//promotion.gogoro.com/tw/windbreaker-giveaway-sp/",
    limit: false,
    code: "EVT217",
    startDate: "2020-01-14",
    endDate: "2020-03-11",
  },
  {
    text: "全車系購車送「極輕都會風雨衣」或「第三年延長保固」二選一",
    link: "//promotion.gogoro.com/tw/extended-warranty-mar-may",
    limit: false,
    code: "EVT217",
    startDate: "2020-03-12",
    endDate: "2020-03-31",
  },
  {
    text: "全車系購車送「第三年延長保固」",
    link: "//promotion.gogoro.com/tw/extended-warranty-mar-may",
    limit: false,
    code: "EVT254",
    startDate: "2020-04-01",
    endDate: "2020-04-12",
  },
  {
    text: "全車系購車送「藍牙耳機」，送完為止",
    link: "//promotion.gogoro.com/tw/flashsale-feb-sp",
    limit: true,
    code: "EVT227",
    startDate: "2020-02-11",
    endDate: "2020-03-01",
  },
  {
    text: "3 系列全新改款送「藍牙耳機」&「好禮三選一」",
    link: "//promotion.gogoro.com/tw/gogoro-3-sp-mar-apr",
    limit: true,
    code: "EVT250",
    startDate: "2020-03-12",
    endDate: "2020-04-30",
  },
  {
    text: "Gogoro 3 系列送「極輕都會風雨衣」",
    link: "//promotion.gogoro.com/tw/gogoro-3-sp-may-june",
    limit: false,
    code: "EVT281",
    startDate: "2020-05-01",
    endDate: "2020-06-01",
  },
  {
    text: "Gogoro VIVA 系列購車金最高 $3,000",
    link: "//promotion.gogoro.com/tw/viva-series-april-sp",
    limit: false,
    code: "EVT264",
    startDate: "2020-04-01",
    endDate: "2020-05-31",
  },
  {
    text: "VIVA 系列 $299 騎到飽再送 $1,000 配件金",
    link: "//promotion.gogoro.com/tw/gogoro-viva-series-june-sp",
    limit: false,
    code: "EVT287",
    startDate: "2020-05-29",
    endDate: "2020-06-30",
  },
  {
    text: "$499 騎到飽，再送最高 $6,000 購車金",
    link: "//promotion.gogoro.com/tw/gogoro-june-july-sp",
    limit: false,
    code: "EVT289",
    startDate: "2020-06-05",
    endDate: "2020-07-14",
  },
  {
    text: "推薦加碼 雙方齊享",
    link: "//promotion.gogoro.com/tw/2020-referral-wave-2",
    limit: false,
    code: "EVT286",
    startDate: "2019-06-01", // origin date: 2020-06-01
    endDate: "2019-07-31", // origin date: 2020-07-31
  },
  {
    text: "指定車款享首年月付 $499 騎到飽",
    link: "//promotion.gogoro.com/tw/gogoro-series-july-aug-sp",
    limit: false,
    code: "EVT309",
    startDate: "2020-07-15",
    endDate: "2020-07-31",
  },
  {
    text: "Gogoro VIVA 系列享首年月付 $299 騎到飽",
    link: "//promotion.gogoro.com/tw/gogoro-series-july-aug-sp",
    limit: false,
    code: "EVT308",
    startDate: "2020-07-15",
    endDate: "2020-07-31",
  },
  {
    text: "首年騎到飽 資費享優惠",
    link: "//promotion.gogoro.com/tw/2020-aycr-promotion",
    limit: false,
    code: "BI013",
    startDate: "2020-08-01",
    endDate: "2020-12-31",
  },
  {
    text: "ABS車款享 第三年延長保固",
    link: "//promotion.gogoro.com/tw/2020-abs-sp-extended-warranty-sep",
    limit: false,
    code: "EVT320",
    startDate: "2020-09-01",
    endDate: "2020-11-01",
  },
  {
    text: "SBS車款送「Gogoro 極輕都會風雨衣」",
    link: "//promotion.gogoro.com/tw/2020-abs-sp-extended-warranty-sep",
    limit: false,
    code: "EVT321",
    startDate: "2020-09-01",
    endDate: "2020-11-01",
  },
  {
    text: "S Performance 專屬購車禮",
    link: "//promotion.gogoro.com/tw/2020-Sperformance-xround-headset-sep",
    limit: false,
    code: "EVT322",
    startDate: "2020-09-01",
    endDate: "2020-09-30",
  },
  {
    text: "振興券消費購車，最高享有$3000配件折扣金",
    link: "//promotion.gogoro.com/tw/gogoro-series-july-aug-sp",
    limit: false,
    code: "EVT305",
    startDate: "2020-07-15",
    endDate: "2020-08-31",
  },
  {
    text: "S Performance 型速未來 專屬購車禮",
    link: "//promotion.gogoro.com/tw/s-xroundearphones-sp",
    limit: false,
    code: "EVT310",
    startDate: "2020-07-15",
    endDate: "2020-08-31",
  },
  {
    text: "S2系列送 XROUND 真無線藍牙耳機",
    link: "//promotion.gogoro.com/tw/2020-sperformance-xround-headset-sep",
    limit: false,
    code: "EVT326",
    startDate: "2020-10-01",
    endDate: "2020-11-01",
  },
  {
    text: "年底購車潮，優惠最高1萬3",
    link: "//promotion.gogoro.com/tw/2020-lastcall-sp-helmet-nov",
    limit: false,
    code: "EVT340",
    startDate: "2020-11-02",
    endDate: "2020-12-31",
  },
  {
    text: "GT系列送聯名款Y 型架斜肩兩用包",
    link: "//promotion.gogoro.com/tw/2020-gt-edition-sp/",
    limit: false,
    code: "EVT324",
    startDate: "2020-10-14",
    endDate: "2020-11-30",
  },
  {
    text: "指定車款購車送延保+超值好禮",
    link: "//promotion.gogoro.com/tw/2021-all-sp-suitcase-jan",
    limit: false,
    code: "EVT348",
    startDate: "2021-01-01",
    endDate: "2021-01-31",
  },
  {
    text: "VIVA MIX上市禮",
    link: "//promotion.gogoro.com/tw/2021-vivamix-24mth-sp",
    limit: false,
    code: "BI016",
    startDate: "2021-02-23",
    endDate: "2021-05-02",
  },
  {
    text: "補助不用等，早鳥來箱挺",
    link: "//promotion.gogoro.com/tw/2021-all-sp-suitcase-jan",
    limit: false,
    code: "EVT366",
    startDate: "2021-02-24",
    endDate: "2021-05-02",
  },
]

// menu step
export const menuStep = [
  {
    code: "color",
    name: "車身顏色",
    fitAllModel: true,
  },
  {
    code: "accessory",
    name: "個人化配件",
    fitAllModel: false,
  },
  {
    code: "combo",
    name: "套件組",
    fitAllModel: false,
  },
]
